import { Component, Input, OnInit, Optional } from '@angular/core';
import {
  IonRouterOutlet,
  ModalController,
  NavController,
} from '@ionic/angular';
import {
  Account,
  createAccountObject,
  createPostObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { openConsent, openFullscreen, openShare } from '../../../helpers';
import { searchEntries, searchStages } from '../../api/search';
import { SubscribeService } from 'src/app/subscribe.service';
import { isBlacklisted } from 'src/app/utils/blacklist';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  @Input() searchText: string;

  isLoading = true;
  cooldown = 600;
  inputInterval;
  searchResults = {
    accounts: { page: 0, lastPage: 0, data: [], total: 0 },
    posts: { page: 0, lastPage: 0, data: [], total: 0 },
  };

  constructor(
    private subscribeService: SubscribeService,
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    @Optional() private routerOutlet: IonRouterOutlet
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.searchText) {
      this.handleInput();
    }
  }

  handleInput() {
    this.cooldown = 600;
    this.isLoading = true;
    this.searchResults = {
      accounts: { page: 0, lastPage: 0, data: [], total: 0 },
      posts: { page: 0, lastPage: 0, data: [], total: 0 },
    };
    if (!this.inputInterval) {
      this.inputInterval = setInterval(() => {
        if (this.cooldown <= 0) {
          window.clearInterval(this.inputInterval);
          this.inputInterval = null;
          if (this.searchText) {
            this.search();
          }
        } else {
          this.cooldown -= 100;
        }
      }, 100);
    }
  }

  search() {
    if (this.searchText !== '') {
      Promise.all([
        searchStages(this.searchText),
        searchEntries(this.searchText),
      ]).then(([accounts, posts]) => {
        this.searchResults = {
          ...this.searchResults,
          accounts: {
            page: accounts.current_page,
            lastPage: accounts.last_page,
            data: accounts.data.map(createAccountObject),
            total: accounts.total,
          },
        };
        this.searchResults = {
          ...this.searchResults,
          posts: {
            page: posts.current_page,
            lastPage: posts.last_page,
            data: posts.data.map(createPostObject),
            total: posts.total,
          },
        };
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  }

  loadMore = (type: 'accounts' | 'posts') => {
    const term = this.searchText;
    const page = this.searchResults[type].page + 1;
    const request =
      type === 'posts'
        ? searchEntries(term, undefined, page)
        : searchStages(term, page);

    request.then(({ data, last_page, current_page, total }) => {
      this.searchResults[type] = {
        data: [
          ...this.searchResults[type].data,
          ...data.map(
            type === 'posts' ? createPostObject : createAccountObject
          ),
        ],
        lastPage: last_page,
        page: current_page,
        total,
      };
    });
  };

  openConsent(url: string, platform) {
    if (!isBlacklisted(url)) {
      openConsent(url, undefined, this.modalCtrl);
    } else {
      openConsent(url, platform, this.modalCtrl);
    }
  }

  goToStage(handle: string) {
    this.navCtrl.navigateForward('/' + handle, { animated: false });
  }

  toggleSubscribe(account: Account) {
    this.subscribeService.toggleSubscribe(account);
  }

  openShare = (post) => openShare(post, this.modalCtrl);

  openFullscreen = ({ post, index }) =>
    openFullscreen(post, index, this.modalCtrl, this.routerOutlet.nativeEl);
}
